import { useEffect } from "react";

export const SITE_URL = "https://noleggioautopontedera.com";
const DEFAULT_IMAGE = `${SITE_URL}/logo-colored.png`;

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, path = "", image }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image || DEFAULT_IMAGE;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Centro Auto Pontedera");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
  }, [title, description, path, image]);
  return null;
};
